// extracted by mini-css-extract-plugin
module.exports = {"OrderSummary":"OrderSummary_OrderSummary__8_D7t","Button":"OrderSummary_Button__xkiZn","Cancel":"OrderSummary_Cancel__2Gdto","Ok":"OrderSummary_Ok__1ux89"};